/**
 * Barra de voltar das telas internas (decisão do PO, 17/09/2026, lote de
 * aparência 1): a barra inferior só existe nas quatro raízes; toda outra
 * tela ganha, no topo, a seta de voltar — e a tela inteira para o conteúdo.
 *
 * Voltar = a tela anterior do histórico do app. Quando não há anterior (a
 * pessoa chegou por notificação ou link), vai para a raiz da aba a que a
 * rota pertence (`rootOf`, @nv/core). O botão do sistema no Android faz o
 * mesmo por conta própria (histórico do navegador).
 */
import { rootOf } from '@nv/core';
import { useLocation, useNavigate } from 'react-router-dom';

import { Icon } from './icons';

export function BarraVoltar() {
  const navigate = useNavigate();
  const { pathname, key } = useLocation();
  // `key === 'default'` é a primeira entrada desta sessão de navegação: não
  // há para onde voltar dentro do app.
  const temAnterior = key !== 'default';
  const voltar = () => {
    if (temAnterior) navigate(-1);
    else navigate(rootOf(pathname), { replace: true });
  };
  return (
    <div className="barra-voltar" data-testid="barra-voltar">
      <button type="button" className="barra-voltar__botao" aria-label="Voltar" onClick={voltar}>
        <Icon name="voltar" size={22} />
      </button>
    </div>
  );
}
